import accountRecoveryTemplate from "./accountRecoveryTemplate";
import accountRecoveryMultipleUsrsTemplate from "./accountRecoveryMultipleUsrsTemplate";
import accountRecoveryConfirmTemplate from "./accountRecoveryConfirmTemplate";
import loginHelpTemplate from "./loginHelpTemplate";
import loginHelpDeliveryOptionsTemplate from "./loginHelpDeliveryOptionsTemplate";
import loginHelpActivationCodeEntryTemplate from "./loginHelpActivationCodeEntryTemplate";

var accountRecoveryRoute = function ($stateProvider, $urlRouterProvider) {

    $stateProvider

        // Account Recovery =================================
        .state('accountRecovery', {
            url: '/account-recovery',
            template: accountRecoveryTemplate,
            controller: 'accountRecoveryController',
            data: {
                fullHeight: true,
                title: 'Login Help'
            }
        })
        .state('accountRecoveryMultipleUsrs', {
            url: '/account-recovery-multipleUsrs',
            template: accountRecoveryMultipleUsrsTemplate,
            controller: 'accountRecoveryController',
            data: {
                fullHeight: true,
                title: 'Login Help'
            }
        })
        //Account Confirmation
        .state('accountRecoveryConfirm', {
            url: '/account-recovery-confirm',
            template: accountRecoveryConfirmTemplate,
            controller: 'accountRecoveryController',
            data: {
                fullHeight: true,
                title: 'Login Help'
            }
        })
        // login help =================================
        .state('loginHelp', {
            url: '/loginHelp?accu',
            template: loginHelpTemplate,
            controller: 'registrationController',
            data: {
                fullHeight: true,
                title: 'Login Help'
            }
        })
        .state('loginHelpDeliveryOptions', {
            url: '/loginHelp/activationCodeDeliveryOptions',
            template: loginHelpDeliveryOptionsTemplate,
            controller: 'mfaController',
            data: {
                fullHeight: true,
                title: 'Login Help'
            }
        })
        .state('verifyCodeForLoginHelp', {
            url: '/loginHelp/verifyCode',
            template: loginHelpActivationCodeEntryTemplate,
            controller: 'mfaVerifyCodeController',
            data: {
                fullHeight: true,
                title: 'Login Help'
            }
        });
};

accountRecoveryRoute.$inject = ['$stateProvider', '$urlRouterProvider'];
export default accountRecoveryRoute;
